import axios from "axios"
import { DeleteDynamicRolesApi, MedicineListApi, addDebitCard, addDynamicRolesApi, addMedicineApi, addTreatmentPlanApi, archiveTreatmentPlanApi, cancelPlan, changeDefaultCard, chargeAmount, createRazorpayUrl, deleteDebitCard, exportMedicineApi, getAutomatedPaymentStatus, getDetailsDynamicRolesApi, getPaymentdetails, importMedicineApi, insertLifeStyle, listDebitCard, listDynamicRolesApi, listLifeStyleApi, listStaffDynamicRolesApi, listnotifications, paymentHistory, planHistory, replyApi, setUpSetting, statusChnageDynamicRolesApi, subcriptionPlanList, ticketListAPi, ticketdetailsAPi, timeZoneListApi, treatmentPlanListApi, updateAutomatedPaymentStatus, updateDynamicRolesApi, updateLifeStyleApi, updateMedicineApi, updateNotifications, updateStatusApi, updateTreatmentPlanApi, updatepin, viewSettingDetails, listInventoryApi, addInventoryApi, updateInventoryApi, listVendorApi, archiveVendorApi, getVendorDetailsApi, updateVendorApi, insertVendorApi, getInventoryDetailsApi, archiveInventoryApi, listCategoryApi, insertCategoryApi, listCategoryProductApi, listProductBatchesApi, requestInventoryApi, requestInventoryHistoryApi, listProductStrengthApi, downloadInventoryApi, downloadVendorApi, stockHistoryApi, addAndReleaseStockApi } from "../../Context/api"
import { axiosInstance } from "../../Context/CraeteAxios"
import handleError from "../../Utils/handleError"


export const UPDATE_SETTING = async (body) => {
    try {
        let response = await axiosInstance.post(setUpSetting(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const VIEW_SETTING_DETAILS = async (body) => {
    try {
        let response = await axiosInstance.post(viewSettingDetails(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

////////////////////////////// CHANGE PIN /////////////////////////////////
export const UPDATE_PIN = async (body) => {
    try {
        let response = await axiosInstance.post(updatepin(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

///////////////////////// Help Desk ///////////////////////////////////////

export const TICKET_LIST = async (body) => {
    try {
        let response = await axios.post(ticketListAPi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const INSERT_TICKET = async (body) => {
    try {
        let response = await axios.post(ticketListAPi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const GET_TICKET_DETAILS = async (body) => {
    try {
        let response = await axios.get(ticketdetailsAPi() + body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const SEND_REPLY = async (body) => {
    try {
        let response = await axios.post(replyApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}


////////////////////////////////// LIFE STYLE  /////////////////////////////

export const INSERT_LIFESTYLE = async (body) => {
    try {
        let response = await axiosInstance.post(insertLifeStyle(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const LIFESTYLE_LIST = async (body) => {
    try {
        let response = await axiosInstance.post(listLifeStyleApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const EDIT_LIFESTYLE = async (body) => {
    try {
        let response = await axiosInstance.post(updateLifeStyleApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

////////////////////////////////// NOTIFICATION  /////////////////////////////

export const GET_NOTIFICATION_DETAILS = async (body) => {
    try {
        let response = await axiosInstance.post(listnotifications(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const UPDATE_NOTIFICATION = async (body) => {
    try {
        let response = await axiosInstance.post(updateNotifications(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

////////////////////////////////// TIME ZONE ///////////////////////////////



export const TIME_ZONE_LIST = async (body) => {
    try {
        let response = await axiosInstance.post(timeZoneListApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}


export const PLAN_LIST = async (body) => {
    try {
        let response = await axiosInstance.post(subcriptionPlanList(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const PLAN_HISTORY = async (body) => {
    try {
        let response = await axiosInstance.post(planHistory(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const PAYMENT_HISTORY = async (body) => {
    try {
        let response = await axiosInstance.post(paymentHistory(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const CANCEL_PLAN = async (body) => {
    try {
        let response = await axiosInstance.post(cancelPlan(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}


export const ADD_DEBIT_CARD = async (body) => {
    try {
        let response = await axiosInstance.post(addDebitCard(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const DEBIT_CARD_LIST = async (body) => {
    try {
        let response = await axiosInstance.post(listDebitCard(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const DEBIT_CARD_DELETE = async (body) => {
    try {
        let response = await axiosInstance.post(deleteDebitCard(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const CHANGE_DEFAULT_CARD = async (body) => {
    try {
        let response = await axiosInstance.post(changeDefaultCard(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const CHANGE_AUTOMATED_PAYMENT_STATUS = async (body) => {
    try {
        let response = await axiosInstance.post(updateAutomatedPaymentStatus(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const GET_AUTOMATED_PAYMENT_STATUS = async (body) => {
    try {
        let response = await axiosInstance.post(getAutomatedPaymentStatus(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const CHARGE_AMOUNT = async (body) => {
    try {
        let response = await axiosInstance.post(chargeAmount(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const CREATE_RAZORPAY_ORDER = async (body) => {
    try {
        let response = await axiosInstance.post(createRazorpayUrl(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const PAYMENT_DETAILS = async (body) => {
    try {
        let response = await axiosInstance.post(getPaymentdetails(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

// roles 

export const INSERT_ROLE = async (body) => {
    try {
        let response = await axiosInstance.post(addDynamicRolesApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const ROLE_LIST = async (body) => {
    try {
        let response = await axiosInstance.post(listDynamicRolesApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const GET_ROLE_DETAILS = async (body) => {
    try {
        let response = await axiosInstance.post(getDetailsDynamicRolesApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const EDIT_ROLE = async (body) => {
    try {
        let response = await axiosInstance.post(updateDynamicRolesApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const CHANGE_ROLE_STATUS = async (body) => {
    try {
        let response = await axiosInstance.post(statusChnageDynamicRolesApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const DELETE_ROLE = async (body) => {
    try {
        let response = await axiosInstance.post(DeleteDynamicRolesApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const ROLE_LIST_STAFF = async (body) => {
    try {
        let response = await axiosInstance.post(listStaffDynamicRolesApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

// -------------------  medicine ------------------------------




export const INSERT_MEDICINE = async (body) => {
    try {
        let response = await axiosInstance.post(addMedicineApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const MEDICINE_LIST = async (body) => {
    try {
        let response = await axiosInstance.post(MedicineListApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const UPDATE_MEDICINE = async (body) => {
    try {
        let response = await axiosInstance.post(updateMedicineApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const ARCHIVE_MEDICINE = async (body) => {
    try {
        let response = await axiosInstance.post(updateStatusApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
// export const EXPORT_MEDICINE = async (body) => {
//     try {
//         let response = await axiosInstance.post(exportMedicineApi(), body)
//         return response.data
//     }
//     catch (error) {
//         handleError(error)
//     }
// }
export const EXPORT_MEDICINE = async (body) => {
    try {
        return await axiosInstance.post(
            exportMedicineApi(),
            body,
            {
                responseType: "blob"
            }
        )
    } catch (error) {
        handleError(error)
    }
}

export const IMPORT_MEDICINE = async (body) => {
    try {
        let response = await axiosInstance.post(importMedicineApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

// ---------------------------------------- inventory -----------------------------
export const LIST_INVENTORY = async (body) => {
    try {
        let response = await axiosInstance.post(listInventoryApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const INSERT_INVENTORY = async (body) => {
    try {
        let response = await axiosInstance.post(addInventoryApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const UPDATE_INVENTORY = async (body) => {
    try {
        let response = await axiosInstance.post(updateInventoryApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const GET_INVENTORY_DETAILS = async (body) => {
    try {
        let response = await axiosInstance.post(getInventoryDetailsApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const ARCHIVE_INVENTORY = async (body) => {
    try {
        let response = await axiosInstance.post(archiveInventoryApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const ADD_RELEASE_INVENTORY = async (body) => {
    try {
        let response = await axiosInstance.post(addAndReleaseStockApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}


export const STOCK_HISTORY_INVENTORY = async (body) => {
    try {
        let response = await axiosInstance.post(stockHistoryApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

// export const DOWNLOAD_INVENTORY = async (body) => {
//     try {
//         let response = await axiosInstance.post(downloadInventoryApi(), body)
//         return response.data
//     }
//     catch (error) {
//         handleError(error)
//     }
// }

export const DOWNLOAD_INVENTORY = async (body) => {
    try {
        let response = await axiosInstance.post(downloadInventoryApi(), body, {
            responseType: "blob"
        });
        return response;
    } catch (error) {
        handleError(error);
    }
};



export const LIST_CATEGORY = async (body) => {
    try {
        let response = await axiosInstance.post(listCategoryApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const INSERT_CATEGORY = async (body) => {
    try {
        let response = await axiosInstance.post(insertCategoryApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const LIST_CATEGORY_PRODUCTS = async (body) => {
    try {
        let response = await axiosInstance.post(listCategoryProductApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const LIST_PRODUCT_BATCHES = async (body) => {
    try {
        let response = await axiosInstance.post(listProductBatchesApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const LIST_PRODUCT_STRENGTH = async (body) => {
    try {
        let response = await axiosInstance.post(listProductStrengthApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const REQUEST_INVENTORY = async (body) => {
    try {
        let response = await axiosInstance.post(requestInventoryApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const REQUEST_INVENTORY_HISTORY = async (body) => {
    try {
        let response = await axiosInstance.post(requestInventoryHistoryApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

// ---------------------------------------- vendor management -----------------------------
export const LIST_VENDOR = async (body) => {
    try {
        let response = await axiosInstance.post(listVendorApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const ARCHIVE_VENDOR = async (body) => {
    try {
        let response = await axiosInstance.post(archiveVendorApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const GET_VENDOR_DETAILS = async (body) => {
    try {
        let response = await axiosInstance.post(getVendorDetailsApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const EDIT_VENDOR_DETAILS = async (body) => {
    try {
        let response = await axiosInstance.post(updateVendorApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const INSERT_VENDOR = async (body) => {
    try {
        let response = await axiosInstance.post(insertVendorApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}

export const DOWNLOAD_VENDOR = async (body) => {
    try {
        let response = await axiosInstance.post(downloadVendorApi(), body, {
            responseType: "blob"
        });
        return response;
    } catch (error) {
        handleError(error);
    }
};


// ---------------------------------------- treatment plan -----------------------------


export const TREATMENT_PLAN_LIST = async (body) => {
    try {
        let response = await axiosInstance.post(treatmentPlanListApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const ADD_TREATMENT_PLAN = async (body) => {
    try {
        let response = await axiosInstance.post(addTreatmentPlanApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const UPDATE_TREATMENT_PLAN = async (body) => {
    try {
        let response = await axiosInstance.post(updateTreatmentPlanApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const ARCHIVE_TREATMENT_PLAN = async (body) => {
    try {
        let response = await axiosInstance.post(archiveTreatmentPlanApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}














